import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (!_ctx.isLegacy)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, "not found error"))
    : _createCommentVNode("", true)
}